import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  content
`

export const getOrdersByDayQuery = (brandId, establishmentId, day) => {
  var debug = `
    query {
      getOrders(brandId: "${brandId}", establishmentId: "${establishmentId}", day:"${day}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getOrders(brandId: "${brandId}", establishmentId: "${establishmentId}", day:"${day}") {
        ${common}
      }
    }
  `;
}

export const getOrdersByRangeQuery = (brandId, establishmentId, startDay, endDay) => {

    var debug = `
    query {
      getOrdersByRange(brandId: "${brandId}", establishmentId: "${establishmentId}", startDay:"${startDay}", endDay:"${endDay}") {
        ${common}
      }
    }
  `
    console.log(debug);

    return gql`
    query {
      getOrdersByRange(brandId: "${brandId}", establishmentId: "${establishmentId}", startDay:"${startDay}", endDay:"${endDay}") {
        ${common}
      }
    }
  `;
}




